import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function AddToCartIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19" {...props}>
        <path d="M10.06 15.328a1.5 1.5 0 1 1 3.002 0 1.5 1.5 0 0 1-3.002 0m1.125 0a.375.375 0 1 0 .75 0 .375.375 0 0 0-.75 0m-7.125 0a1.5 1.5 0 1 1 3.002 0 1.5 1.5 0 0 1-3.002 0m1.125 0a.375.375 0 1 0 .75 0 .375.375 0 0 0-.75 0m-.85-2.03a.564.564 0 0 1-.514-.79l.807-1.83-2.041-5.303H.562a.563.563 0 0 1 0-1.125h2.414a.56.56 0 0 1 .525.36l.382.991h10.16a.56.56 0 0 1 .53.751l-1.588 4.459a.565.565 0 0 1-.53.375H5.637l-.437.99h7.934a.561.561 0 0 1 0 1.126l-8.8-.003Zm1.264-3.23a1 1 0 0 1 .096-.008h6.36l1.187-3.334h-8.93z" />
        <circle
          cx={14.25}
          cy={4.25}
          r={4.125}
          stroke="#fff"
          strokeWidth={0.75}
        />
        <path
          fill="#fff"
          d="M13.875 6.125v-1.5h-1.5a.375.375 0 1 1 0-.75h1.5v-1.5a.375.375 0 1 1 .75 0v1.5h1.5a.375.375 0 1 1 0 .75h-1.5v1.5a.375.375 0 1 1-.75 0"
        />
      </svg>
    </Icon>
  )
}
export default AddToCartIcon
